<template>
  <div class="ord">
    <!-- 查询条件区（单模块） -->
    <div class="ord-filters">
      <div class="ord-filters__head">
        <i class="el-icon-s-order ord-filters__title-ico" aria-hidden="true" />
        <h1 class="ord-filters__h">订单管理</h1>
      </div>
      <div class="ord-filters__row">
        <div class="ord-filters__field">
          <span class="ord-filters__label">时间范围</span>
          <div class="ord-sel-wrap">
            <el-select
              v-model="filters.timeRange"
              class="ord-sel"
              popper-class="ord-select-popper"
            >
              <el-option label="全部" value="" />
              <el-option label="今日" value="today" />
              <el-option label="本周" value="week" />
              <el-option label="本月" value="month" />
            </el-select>
            <img class="ord-sel-ico" :src="sliceOrder('select.png')" alt="" role="presentation" />
          </div>
        </div>
        <div class="ord-filters__field">
          <span class="ord-filters__label">选择币种</span>
          <div class="ord-sel-wrap">
            <el-select
              v-model="filters.coin"
              class="ord-sel"
              popper-class="ord-select-popper"
              clearable
              placeholder="全部"
              @change="onCoinChange"
            >
              <el-option v-for="o in coinSelectOptions" :key="'c-' + o.value" :label="o.label" :value="o.value" />
            </el-select>
            <img class="ord-sel-ico" :src="sliceOrder('select.png')" alt="" role="presentation" />
          </div>
        </div>
        <div class="ord-filters__field">
          <span class="ord-filters__label">链</span>
          <div class="ord-sel-wrap">
            <el-select
              v-model="filters.chain"
              class="ord-sel"
              popper-class="ord-select-popper"
              :disabled="chainSelectOptions.length <= 1"
              placeholder="全部"
            >
              <el-option v-for="o in chainSelectOptions" :key="'h-' + o.value" :label="o.label" :value="o.value" />
            </el-select>
            <img class="ord-sel-ico" :src="sliceOrder('select.png')" alt="" role="presentation" />
          </div>
        </div>
        <div class="ord-filters__field">
          <span class="ord-filters__label">商户 ID</span>
          <el-input
            v-model="filters.merchantId"
            class="ord-filters__input ord-filters__input--narrow"
            clearable
            placeholder="选填"
            @keyup.enter.native="load(1)"
          />
        </div>
        <div class="ord-filters__field ord-filters__field--name">
          <span class="ord-filters__label">商户名称</span>
          <el-input
            v-model="filters.merchantName"
            class="ord-filters__input"
            clearable
            placeholder="模糊搜索"
            @keyup.enter.native="load(1)"
          >
            <i slot="prefix" class="el-input__icon el-icon-search" />
          </el-input>
        </div>
        <div class="ord-filters__field ord-filters__field--flex">
          <span class="ord-filters__label">用户标识</span>
          <el-input
            v-model="filters.userKeyword"
            class="ord-filters__input"
            clearable
            placeholder="搜索用户ID..."
            @keyup.enter.native="load(1)"
          >
            <i slot="prefix" class="el-input__icon el-icon-search" />
          </el-input>
        </div>
        <div class="ord-filters__actions">
          <button type="button" class="ord-btn ord-btn--ghost" @click="resetFilters">
            <img class="ord-btn__ico" :src="sliceOrder('reset.png')" alt="" />
            重置
          </button>
          <button type="button" class="ord-btn ord-btn--query" @click="load(1)">查询</button>
        </div>
      </div>
    </div>

    <!-- 订单列表区（单模块） -->
    <div class="ord-list">
      <el-table v-loading="loading" :data="rows" class="ord-table" style="width: 100%" size="small">
        <el-table-column label="商户" min-width="120">
          <template slot-scope="scope">
            <span class="cell-muted">{{ scope.row.merchantName || '—' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="userId" label="用户标识" min-width="100">
          <template slot-scope="scope">
            <span class="cell-muted">{{ scope.row.userId }}</span>
          </template>
        </el-table-column>
        <el-table-column label="币种" width="100">
          <template slot-scope="scope">
            <span class="coin-pill" :class="'coin-pill--' + String(scope.row.coin || '').toLowerCase()">
              <img v-if="coinIcon(scope.row.coin)" :src="coinIcon(scope.row.coin)" alt="" class="coin-pill__ico" />
              {{ scope.row.coin }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="链" width="100">
          <template slot-scope="scope">
            <span class="chain-pill">{{ displayChain(scope.row) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="金额" min-width="120">
          <template slot-scope="scope">
            <span>{{ fmtAmount(scope.row.amount) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="地址" min-width="200">
          <template slot-scope="scope">
            <explorer-cell kind="address" :chain="scope.row.rawChain" :value="scope.row.address" />
          </template>
        </el-table-column>
        <el-table-column prop="txHash" label="交易 HASH" min-width="120">
          <template slot-scope="scope">
            <explorer-cell kind="tx" :chain="scope.row.rawChain" :value="scope.row.txHash" />
          </template>
        </el-table-column>
        <el-table-column label="换算 USDT" min-width="120">
          <template slot-scope="scope">
            <span class="ord-usdt-val">{{ fmtAmount(scope.row.usdt) }}</span>
            <span class="ord-usdt-unit">USDT</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" min-width="150">
          <template slot-scope="scope">
            <span class="cell-muted cell-time">{{ timeLine(scope.row.createdAt) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="到账时间" min-width="150">
          <template slot-scope="scope">
            <span class="cell-time cell-arrival">{{ timeLine(scope.row.arrivedAt) }}</span>
          </template>
        </el-table-column>
      </el-table>

      <div class="ord-pager">
        <span class="ord-pager__sum">显示 {{ rangeFrom }} - {{ rangeTo }} / 共 {{ total | formatTotal }} 条记录</span>
        <el-pagination
          class="ord-pager__el"
          background
          layout="sizes, prev, pager, next, jumper"
          :page-sizes="[10, 15, 20, 50]"
          :current-page="page"
          :page-size="pageSize"
          :total="total"
          @size-change="onSize"
          @current-change="onPage"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { adminApi } from '@/api/admin'
import ExplorerCell from '@/components/ExplorerCell.vue'

export default {
  name: 'AdminOrdersView',
  components: { ExplorerCell },
  filters: {
    formatTotal(n) {
      return Number(n || 0).toLocaleString('en-US')
    }
  },
  computed: {
    coinSelectOptions() {
      return [
        { label: '全部', value: '' },
        { label: 'BTC', value: 'BTC' },
        { label: 'ETH', value: 'ETH' },
        { label: 'USDT', value: 'USDT' }
      ]
    },
    chainSelectOptions() {
      const c = (this.filters.coin || '').toUpperCase()
      if (c === 'USDT') {
        return [
          { label: '全部', value: '' },
          { label: 'TRC20', value: 'TRC20' },
          { label: 'ERC20', value: 'ERC20' },
          { label: 'BRC20', value: 'BRC20' }
        ]
      }
      if (c === 'BTC' || c === 'ETH') {
        return [
          { label: '全部', value: '' },
          { label: 'Native', value: 'Native' }
        ]
      }
      return [{ label: '全部', value: '' }]
    },
    rangeFrom() {
      if (!this.total) return 0
      return (this.page - 1) * this.pageSize + 1
    },
    rangeTo() {
      if (!this.total) return 0
      return Math.min(this.page * this.pageSize, this.total)
    }
  },
  data() {
    return {
      loading: false,
      page: 1,
      pageSize: 15,
      total: 0,
      rows: [],
      filters: {
        timeRange: '',
        coin: '',
        chain: '',
        userKeyword: '',
        merchantId: '',
        merchantName: ''
      }
    }
  },
  created() {
    // 下拉面在 body 选中项右侧勾图；用 CSS 变量，勿在 scss 里写 url('/slices/...') 以免 webpack 解析失败；下拉三角用模板里的 select.png
    document.documentElement.style.setProperty(
      '--ord-choose-merchant-orders',
      `url('${this.sliceOrder('choose.png')}')`
    )
  },
  mounted() {
    this.load(1)
  },
  beforeDestroy() {
    document.documentElement.style.removeProperty('--ord-choose-merchant-orders')
  },
  methods: {
    base() {
      return process.env.BASE_URL || '/'
    },
    sliceOrder(name) {
      return this.base() + 'slices/order/' + encodeURIComponent(name)
    },
    onCoinChange() {
      const allowed = this.chainSelectOptions.map((o) => o.value)
      if (this.filters.chain && !allowed.includes(this.filters.chain)) {
        this.filters.chain = ''
      }
    },
    /** BTC/ETH 在界面展示为 Native，查询仍用库内实际 chain 调区块浏览器 */
    displayChain(row) {
      const c = String(row.coin || '').toUpperCase()
      if (c === 'BTC' || c === 'ETH') return 'Native'
      return row.rawChain || '—'
    },
    coinIcon(coin) {
      const u = String(coin || '').toUpperCase()
      if (u === 'BTC') return this.base() + 'slices/btc.png'
      if (u === 'ETH') return this.base() + 'slices/eth.png'
      if (u === 'USDT') return this.base() + 'slices/usdt.png'
      return ''
    },
    fmtAmount(v) {
      const n = parseFloat(v)
      if (!Number.isFinite(n)) return '0.00'
      return n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    timeLine(s) {
      if (!s || s === '—') return '—'
      if (typeof s === 'string') {
        const p = s.split(' ')
        return p.length >= 2 ? `${p[0]} ${p[1]}` : s
      }
      return String(s)
    },
    mapRow(r) {
      return {
        merchantName: (r.merchant && r.merchant.name) || '',
        userId: r.user_uid,
        coin: r.coin,
        rawChain: r.chain,
        chain: r.chain,
        amount: r.amount,
        address: r.address,
        txHash: r.tx_hash,
        usdt: r.amount_usdt,
        createdAt: r.created_at || r.chain_time,
        arrivedAt: r.confirmed_at || '—'
      }
    },
    buildParams() {
      const p = { page: this.page, page_size: this.pageSize }
      if (this.filters.timeRange) p.time_range = this.filters.timeRange
      if (this.filters.coin) p.coin = this.filters.coin
      if (this.filters.chain) p.chain = this.filters.chain
      if (this.filters.userKeyword) p.keyword = this.filters.userKeyword.trim()
      const mid = String(this.filters.merchantId || '').trim()
      if (mid) p.merchant_id = mid
      if (this.filters.merchantName) p.merchant_name = this.filters.merchantName.trim()
      return p
    },
    async load(page) {
      if (page) this.page = page
      this.loading = true
      try {
        const res = await adminApi.orders(this.buildParams())
        this.total = (res.data && res.data.total) || 0
        this.rows = (res.data.list || []).map((r) => this.mapRow(r))
      } catch (e) {
        this.rows = []
        this.total = 0
        this.$message.error((e && e.message) || '订单列表加载失败')
      } finally {
        this.loading = false
      }
    },
    onPage(p) {
      this.page = p
      this.load()
    },
    onSize(n) {
      this.pageSize = n
      this.load(1)
    },
    resetFilters() {
      this.filters = {
        timeRange: '',
        coin: '',
        chain: '',
        userKeyword: '',
        merchantId: '',
        merchantName: ''
      }
      this.load(1)
    }
  }
}
</script>

<style lang="scss" scoped>
.ord {
  max-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.ord-filters {
  box-sizing: border-box;
  min-height: 182px;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 24px;
  border: 1px solid #f3f4f6;
  padding: 16px 20px 14px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: 0px 4px 24px 0px rgba(0, 0, 0, 0.02);
  overflow: visible;
}

.ord-filters__head {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
}

.ord-filters__title-ico {
  font-size: 20px;
  color: #2563eb;
}

.ord-filters__h {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
}

.ord-filters__row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 12px 20px;
}

.ord-filters__field {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  min-width: 0;
  &--flex {
    flex: 1.2;
    min-width: 200px;
    max-width: 320px;
  }
  &--name {
    flex: 1;
    min-width: 180px;
    max-width: 280px;
  }
}

.ord-filters__label {
  font-size: 12px;
  font-weight: 500;
  color: #64748b;
  line-height: 1.2;
}

/* public/slices/order/select.png：用 img 直链，不走路由打包 */
.ord-sel-wrap {
  position: relative;
  width: 156px;
  flex-shrink: 0;
  &:has(.el-icon-circle-close) .ord-sel-ico {
    display: none;
  }
  &:has(.is-disabled) .ord-sel-ico {
    opacity: 0.4;
  }
}
.ord-sel-ico {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  object-fit: contain;
  pointer-events: none;
  z-index: 2;
}

.ord-sel {
  width: 100%;
  position: relative;
  flex-shrink: 0;
  ::v-deep .el-input__inner {
    border-radius: 10px;
    height: 36px;
    line-height: 36px;
    border: 1px solid #e2e8f0;
    font-size: 13px;
    color: #0f172a;
    padding-left: 12px;
    padding-right: 32px;
    background: #fff;
  }
  ::v-deep .el-input__suffix {
    right: 8px;
    width: 18px;
  }
  /* 隐藏默认三角，右侧由 .ord-sel-ico 显示 select.png */
  ::v-deep .el-input__suffix .el-select__caret.el-icon-arrow-up {
    opacity: 0 !important;
  }
  ::v-deep .el-icon-circle-close {
    position: relative;
    z-index: 3;
  }
  &.is-disabled ::v-deep .el-input__inner {
    background: #f8fafc;
    color: #94a3b8;
  }
}

.ord-filters__input {
  width: 100%;
  min-width: 0;
  ::v-deep .el-input__inner {
    height: 36px;
    line-height: 36px;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    font-size: 13px;
    padding-left: 34px;
  }
}

.ord-filters__input--narrow {
  max-width: 140px;
  ::v-deep .el-input__inner {
    padding-left: 12px;
  }
}

.ord-filters__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
  padding-bottom: 0;
  flex-wrap: wrap;
}

.ord-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 36px;
  padding: 0 16px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  border: 1px solid transparent;
  transition: background 0.15s, border-color 0.15s, color 0.15s, filter 0.12s;
}
.ord-btn__ico {
  width: 16px;
  height: 16px;
  object-fit: contain;
  display: block;
}
.ord-btn--ghost {
  background: #fff;
  color: #475569;
  border-color: #e2e8f0;
  &:hover {
    background: #f8fafc;
    border-color: #cbd5e1;
  }
}
.ord-btn--query {
  color: #fff;
  background: #3b82f6;
  border-color: #3b82f6;
  padding: 0 20px;
  &:hover {
    filter: brightness(1.05);
  }
  &:active {
    filter: brightness(0.98);
  }
}

/* 列表卡 */
.ord-list {
  background: #fff;
  border-radius: 24px;
  border: 1px solid #f1f5f9;
  padding: 20px 20px 16px;
  box-shadow: 0px 4px 24px 0px rgba(0, 0, 0, 0.04);
}

::v-deep .ord-table {
  th {
    color: #64748b;
    font-weight: 500;
    font-size: 12px;
    background: #f8fafc;
  }
  .cell {
    color: #334155;
  }
  td {
    border-bottom: 1px solid #f1f5f9;
  }
}

.ord-usdt-val {
  font-weight: 700;
  color: #0f172a;
  margin-right: 4px;
}
.ord-usdt-unit {
  font-size: 12px;
  font-weight: 500;
  color: #94a3b8;
}

.ord-pager {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px 16px;
  margin-top: 16px;
  padding-top: 8px;
}
.ord-pager__sum {
  font-size: 13px;
  color: #64748b;
}
.ord-pager__el {
  flex: 1;
  display: flex;
  justify-content: flex-end;
  min-width: 0;
  ::v-deep .el-pager li.active {
    background: #3b82f6 !important;
  }
  ::v-deep .el-pager li:hover {
    color: #3b82f6;
  }
}

.cell-muted {
  color: #64748b;
  font-size: 13px;
}
.cell-time {
  font-size: 12px;
  white-space: nowrap;
}
.cell-arrival {
  color: #10b981;
  font-weight: 500;
}

.coin-pill {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
}
.coin-pill--btc {
  background: rgba(255, 152, 0, 0.18);
  color: #c2410c;
}
.coin-pill--eth {
  background: rgba(129, 140, 248, 0.2);
  color: #4f46e5;
}
.coin-pill--usdt {
  background: rgba(244, 114, 182, 0.2);
  color: #be185d;
}
.coin-pill__ico {
  width: 16px;
  height: 16px;
  object-fit: contain;
}

.chain-pill {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 6px;
  background: #f1f5f9;
  font-size: 12px;
  color: #475569;
}
</style>

<style lang="scss">
/* 下拉面：选中项右侧 choose.png，需用父级上挂的 --ord-choose，故包一层在 .ord 内也可由 body 下 popper 继承不到变量时单独写 */
.ord-select-popper.el-select-dropdown {
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
}
.ord-select-popper .el-select-dropdown__item {
  position: relative;
  padding-right: 36px;
  font-size: 13px;
}
.ord-select-popper .el-select-dropdown__item.selected {
  color: #2563eb;
  font-weight: 600;
  background: rgba(37, 99, 235, 0.06);
}
.ord-select-popper .el-select-dropdown__item.selected::after {
  content: '';
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  background: var(--ord-choose-merchant-orders) center / contain no-repeat;
}
</style>
